// src/service/CodigosManuales.js
import instance from "../apis/app";

class CodigosManualesService {
  // Listar códigos con filtros y paginación
  async List(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const response = await instance.get(`/codigos-manuales${queryString ? `?${queryString}` : ''}`);
    return response;
  }

  // Obtener código por ID
  async Get(id) {
    const response = await instance.get(`/codigo-manual/${id}`);
    return response.data;
  }

  // Crear código
  async Create(data) {
    const response = await instance.post(`/codigo-manual`, data);
    return response.data;
  }

  // Actualizar código
  async Update(id, data) {
    const response = await instance.put(`/codigo-manual/${id}`, data);
    return response.data;
  }

  // Eliminar código
  async Delete(id) {
    const response = await instance.delete(`/codigo-manual/${id}`);
    return response.data;
  }

  // Toggle activo
  async ToggleActivo(id) {
    const response = await instance.patch(`/codigo-manual/${id}/toggle`);
    return response.data;
  }

  // Validar código en venta presencial
  async Validar(codigo, tallerId) {
    const response = await instance.post(`/codigo-manual/validar`, { codigo, tallerId });
    return response;
  }

  // Registrar uso del código al confirmar la venta
  async IncrementarUso(codigo) {
    const response = await instance.patch(`/codigo-manual/usar/${encodeURIComponent(codigo)}`);
    return response;
  }
}

export default new CodigosManualesService();
